// Warstwa API „Asystenta doboru zestawu PV" (KONTRAKT §1).
//
// JAK PODŁĄCZYĆ PRAWDZIWE BACKENDOWE API:
// 1. Ustaw REACT_APP_KITS_API_URL na endpoint z kontraktu (domyślnie /api/v1/kits).
// 2. Zmień USE_MOCK poniżej na false.
// Kształt żądania i odpowiedzi jest 1:1 z §1 — żaden komponent nie wymaga zmian.
import { mockSuggest } from './kitsMock';
import { zdarzenie } from '../lib/pomiar';
import { aktywnosc } from '../lib/aktywnosc';
import { apiFetch } from './apiFetch';

const USE_MOCK = false;
const BASE_URL = process.env.REACT_APP_KITS_API_URL || '/api/v1/kits';
const MOCK_DELAY_MS = 450;

const delay = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

// POST /api/v1/kits/suggest — stateless. Zwraca kształt §1 (variants / preference_costs
// / no_results). Rzuca Error z .status i .body przy 400/5xx (front pokazuje error_pl).
export const suggestKits = async (payload) => {
  if (USE_MOCK) {
    await delay(MOCK_DELAY_MS);
    return mockSuggest(payload);
  }
  const res = await apiFetch(`${BASE_URL}/suggest`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.error_pl || `Kits API error ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  zdarzenie('asystent_wynik', body?.no_results ? 'brak' : 'warianty');
  aktywnosc('asystent_wynik', { wynik: body?.no_results ? 'brak' : 'warianty' });
  return body;
};
